import * as React from 'react';
import classNames from 'utils/classNames';
import './input.css';
import { InputInterface } from './index.d';

/**
 * @deprecated
 */
const Input: React.StatelessComponent<InputInterface> = React.forwardRef(
  (
    { valid = true, withIcon = false, children, theme = '', ...props },
    ref: React.RefObject<HTMLInputElement>,
  ) => {
    const classes = classNames({
      error: !valid,
      withIcon,
      [theme]: !!theme,
      legacyInput: true,
    });

    return (
      <>
        <input className={classes} {...props} ref={ref} />
        {children}
      </>
    );
  },
);

export default Input;
